<form
  class="rounded-mb flex w-full flex-col justify-center"
  (ngSubmit)="onSubmit()"
  [formGroup]="form">
  <div class="flex w-full flex-col gap-2">
    <div class="">
      <p class="text-left font-semibold">{{ nameKey | translate }}</p>
      <input
        formControlName="name"
        class="border-default bg-elevated focus:ring-accent-focus mt-1 w-full rounded-md border-2 py-2 ps-2 text-sm text-zinc-900 placeholder:text-zinc-400 focus:ring-2 focus:outline-none dark:text-white dark:placeholder:text-zinc-500"
        [class.border-red-500]="form.get('name')?.invalid && form.get('name')?.touched"
        placeholder="{{ nameKey | translate }}"
        type="text" />

      @if (form.get('name')?.invalid && form.get('name')?.touched) {
      <div class="mt-1 text-sm text-red-500">
        @if (form.get('name')?.errors?.['required']) {
        <div>{{ 'form.error.required' | translate }}</div>
        } @if (form.get('name')?.errors?.['minlength']) {
        <div>
          {{ 'form.error.minlength' | translate: form.get('name')?.errors?.['minlength'] }}
        </div>
        }
      </div>
      }
    </div>
    <div>
      <p class="text-left font-semibold">{{ descriptionKey | translate }}</p>
      <textarea
        formControlName="description"
        class="border-default bg-elevated mt-2 h-12 w-full rounded-md border-2">
      </textarea>
    </div>

    <div class="mt-4 flex w-full justify-center gap-10">
      <button
        type="button"
        class="btn-zinc w-full px-4 py-2 disabled:opacity-50"
        (click)="onCancel()">
        {{ cancelKey | translate }}
      </button>
      <button
        class="btn-primary w-full px-4 py-2"
        [class.opacity-50]="form.invalid"
        [disabled]="form.invalid"
        type="submit">
        {{ submitKey | translate }}
      </button>
    </div>
  </div>
</form>
